import React from 'react';
import PropTypes from 'prop-types';

function TabPanel({ id, active, children }) {
  return (
    <div
      role="tabpanel"
      id={`sales-tabpanel-${id}`}
      aria-labelledby={`sales-tab-${id}`}
      hidden={id !== active}
    >
      {children}
    </div>
  );
}

TabPanel.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.string.isRequired,
  children: PropTypes.node
};

TabPanel.defaultProps = {
  children: null
};

export default TabPanel;
